export default __webpack_public_path__ + "static/media/title_m.62e5d014.jpg";